import { axiosInstance } from '@/api/client';

interface ClientLogEntry {
  level: 'error' | 'warn';
  message: string;
  context: string;
}

// Fire-and-forget: namjerno ne ide kroz orval/React Query sloj (queryClient.tsx
// bi neuspješno slanje tretirao kao još jednu API grešku — rekurzija koju
// treba izbjeći). Ako slanje ne uspije, samo se ispiše na konzolu, bez retry-a.
export const sendClientLog = (entry: ClientLogEntry): void => {
  axiosInstance.post('/api/v1/client-logs', { ...entry, url: window.location.href }).catch(() => {
    console.warn('[ClientLog] Failed to reach server — logged locally only.');
  });
};
